import type { SxProps, Theme } from "@mui/material/styles";

export const deliveryPeopleInfoIconSx: SxProps<Theme> = {
  color: "#000000",
};

export const mapAreaViewEditButtonSx: SxProps<Theme> = {
  width: "100%",
};

export const selectDeliveryEditButtonSx: SxProps<Theme> = {
  width: "250px",
};

export const mapAreaEditDriversStackSx: SxProps<Theme> = {
  width: "100%",
};

export const mapAreaSlotAutocompleteListboxProps = {
  sx: {
    "& .MuiAutocomplete-option": {
      "&:hover": {
        backgroundColor: "#D331001F",
      },
      "&.Mui-focused": {
        backgroundColor: "#D331001F",
      },
    },
  },
} as const;

export const mapAreaSlotAutocompleteSx: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
};

export function getMapAreaSlotDeleteIconButtonSx(
  hasDriverSelected: boolean,
): SxProps<Theme> {
  return {
    ...(hasDriverSelected ? { color: "#D33100" } : {}),
    "&:hover": {
      backgroundColor: "transparent",
      boxShadow: "none",
      ...(hasDriverSelected ? { color: "#D33100" } : {}),
    },
    "&:active": {
      backgroundColor: "transparent",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "transparent",
    },
  };
}

export const mapAreaAddAnotherDriverRowSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  width: "100%",
};

export const nonMapAreaDriverAutocompleteSx: SxProps<Theme> = {
  width: 200,
};

export function getDeliveryPeoplePriorityTooltipComponentsProps(theme: Theme) {
  return {
    tooltip: {
      sx: {
        bgcolor: "#000000",
        color: "#FFFFFF",
        maxWidth: 320,
        whiteSpace: "pre-line",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.caption.fontSize,
        fontWeight: 400,
        fontStyle: "normal",
        lineHeight: theme.typography.caption.lineHeight,
        letterSpacing: theme.typography.caption.letterSpacing,
      },
    },
  };
}
